import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import '../sso-workspace/sso-workspace.scss'
import './drawer.scss'

// The one slide-out panel (audit-trail spec §5): a right-side panel on
// desktop, a bottom sheet on phones (≤ 576 px). Escape, the Close button and
// a click on the backdrop close it. Extracted from the SSO workspace's
// .sw-drawer, whose colour tokens it keeps (the class stays on the root).
//
// Escape pressed inside the panel is handled there and stopped, so it does
// only that (a page's own document listeners, such as the claim chips', never
// see it). Escape pressed anywhere else reaches the document listener.
//
// back = { label, onClick } renders "← Back to {label}" (the panel was opened
// from somewhere else, such as an audit entry).
//
// phone = "full" fills a phone's screen instead of the bottom sheet (the
// email panel: a long timeline reads better full screen).
export const Drawer = ({ open, title, label, onClose, back, size = 'md', phone = 'sheet', children }) => {
  const onCloseRef = useRef(onClose)
  onCloseRef.current = onClose

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => {
      if (e.key !== 'Escape') return
      if (onCloseRef.current) onCloseRef.current()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  if (!open) return null

  const handleKeyDown = e => {
    if (e.key !== 'Escape') return
    e.stopPropagation()
    if (onClose) onClose()
  }

  return createPortal(
    <div className="edxr-drawer sw-drawer" onKeyDown={handleKeyDown} onClick={e => { if (e.target === e.currentTarget && onClose) onClose() }}>
      <div className={`edxr-drawer-panel sw-drawer-panel edxr-drawer-${size}${phone === 'full' ? ' edxr-drawer-phone-full' : ''}`} role="dialog" aria-modal="true" aria-label={label || title}>
        <div className="edxr-drawer-head">
          {back && <button type="button" className="btn btn-link p-0 edxr-drawer-back" onClick={back.onClick}>{`← Back to ${back.label}`}</button>}
          <h2 className="h5 m-0 flex-fill">{title}</h2>
          {onClose && <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />}
        </div>
        {children}
      </div>
    </div>,
    document.body
  )
}
